import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

const API_URL = process.env.REACT_APP_API_URL;

// ────────────────────────────────────────────────────────────
//  Helpers
// ────────────────────────────────────────────────────────────
const postJson = async (url, payload) =>
    axios.post(url, payload, { headers: { 'Content-Type': 'application/json' } });

const postForm = async (url, formData) =>
    axios.post(url, formData, { headers: { 'Content-Type': 'multipart/form-data' } });

// ─────────────────────────  Ortak Backdrop  ─────────────────────────
// Bootstrapʼin kendi .modal-backdrop sınıfıyla beraber extra blur efekti veriyoruz.
const Backdrop = () => (
    <div
        className="modal-backdrop fade show"
        style={{ backdropFilter: 'blur(3px)', zIndex: 1050 }}
    />
);

// Helper: ortak modal wrapper (backdrop + dialog)
const ModalShell = ({ children }) => (
    <>
        <Backdrop />
        {children}
    </>
);

// ────────────────────────────────────────────────────────────
//  StartReportModal
// ────────────────────────────────────────────────────────────
export function StartExamModal({ show, onClose, examInfo, onSaved }) {
    const [startedOk, setStartedOk] = useState(true);
    const [note, setNote] = useState('');
    const [saving, setSaving] = useState(false);

    if (!show) return null;

    // Zaten kaydedilmişse formu pasif yap
    const alreadyDone = examInfo.hasStartReport;

    const handleSave = () => {
        if (alreadyDone) return onClose();
        setSaving(true);
        postJson(`${API_URL}/Custom/CreateStartReport`, {
            timeSlotId: examInfo.timeSlotId,
            classroomId: examInfo.classroomId,
            startedOk,
            note
        })
            .then(() => {
                Swal.fire({ icon: 'success', title: 'Kayıt alındı', timer: 1200, showConfirmButton: false });
                onSaved?.('start', examInfo);           // ► parent butonu güncellesin
                onClose();
            })
            .catch(() => Swal.fire('Hata', 'Kayıt sırasında sorun oluştu', 'error'))
            .finally(() => setSaving(false));
    };

    return (
        <ModalShell>
            <div className="modal fade show" style={{ display: 'block', zIndex: 1051 }}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Sınav Başlatma Raporu</h5>
                            <button className="btn-close" onClick={onClose} />
                        </div>
                        <div className="modal-body">
                            <p className="mb-3">
                                <strong>{examInfo.examName}</strong> – {examInfo.classroomCode}<br />
                                {examInfo.date} {examInfo.startTime}-{examInfo.endTime}
                            </p>
                            {alreadyDone && (
                                <div className="alert alert-success d-flex align-items-center" role="alert">
                                    <i className="bi bi-check-circle me-2" /> Bu sınav zaten başlatıldı.
                                </div>
                            )}
                            {!alreadyDone && (
                                <>
                                    <div className="form-check form-switch mb-3">
                                        <input type="checkbox" className="form-check-input" id="startedOk"
                                            checked={startedOk} onChange={e => setStartedOk(e.target.checked)} />
                                        <label htmlFor="startedOk" className="form-check-label">
                                            Sınav zamanında ve sorunsuz başlatıldı
                                        </label>
                                    </div>
                                    <textarea rows={3} className="form-control" placeholder="Açıklama (isteğe bağlı)"
                                        value={note} onChange={e => setNote(e.target.value)} />
                                </>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={onClose}>Kapat</button>
                            {!alreadyDone && (
                                <button className="btn btn-success" onClick={handleSave} disabled={saving}>Kaydet</button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </ModalShell>
    );
}